import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';


//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//APIS
import { seminerGetAll } from '../../../apis/seminer';

const OgrenciBasvurular = () => {

    //STATES
    const [seminerLIST, setSeminerLIST] = useState([])
    const [open, setOpen] = useState(false)
    const [aciklama, setAciklama] = useState("")


    const getSeminerLIST = async () => {
        let result = await seminerGetAll(3)
        if (result.status === 200) {
            setSeminerLIST(result.data)
        }
    }

    useEffect(() => {
        getSeminerLIST()
    }, []);


    return (
        <>
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500 '>Başvurularım</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                <div className='w-full'>
                                    <div className='bg-white rounded-lg p-4 min-h-0 overflow-x-auto'>
                                        <table className='w-full table-auto'>
                                            <thead className='bg-slate-100'>
                                                <tr>
                                                    <td className='px-4 py-2 whitespace-nowrap'>Başvuru No</td>
                                                    <td className='px-4 py-2 whitespace-nowrap'>Dönemi</td>
                                                    <td className='px-4 py-2 whitespace-nowrap text-center'>Durum</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    seminerLIST?.length > 0 ? (
                                                        seminerLIST.map((item, key) => (
                                                            <tr key={key} className='even:bg-slate-50 odd:bg-white'>
                                                                <td className='px-4 py-3 whitespace-nowrap underline'>
                                                                    <Link target='blank' to={`/seminer-print/` + item.seminerCode} className='hover:text-blue-500'><strong>{item.seminerCode}</strong></Link>
                                                                </td>
                                                                <td className='px-4 py-3 whitespace-nowrap'>{item.donem.donemName}</td>
                                                                <td className='px-4 py-3 whitespace-nowrap text-center space-x-2'>

                                                                    {
                                                                        item.seminerDurum === 1 ? (
                                                                            <span className='bg-slate-200 text-slate-600 py-1 px-2 rounded-3xl'>Bekliyor</span>
                                                                        ) : item.seminerDurum === 2 ? (
                                                                            <span className='bg-teal-200 text-teal-600 py-1 px-2 rounded-3xl'>Onaylandı</span>
                                                                        ) : (
                                                                            <>
                                                                                <span className='bg-red-200 text-red-600 py-1 px-3 rounded-3xl'>Red</span>
                                                                                <button onClick={() => {
                                                                                    setAciklama(item.seminerDurumAciklama)
                                                                                    setOpen(true)
                                                                                 }} className='bg-blue-200 text-blue-600 hover:bg-blue-400 py-1 px-3 rounded-3xl'>
                                                                                    Açıklama
                                                                                </button>
                                                                            </>
                                                                        )
                                                                    }

                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={3} className='px-4 py-3'>Kayıt bulunamamıştır.</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-50 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                    <div>
                                        <div className="mt-3 text-center sm:mt-5">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                Başvuru Red Açıklama
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    {aciklama}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-6">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-slate-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600"
                                            onClick={() => setOpen(false)}
                                        >
                                            Tamam
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}

export default OgrenciBasvurular;
